<template>
	<div class="main-actions">

		<span style="color: #1a3856">

			<strong>Bonell+Dòriga</strong>
      </span>

		<div class="foot">
			<div class="dropdown">
				<button class="button-icon lnr-list" @click="goTo('dashboard')"></button>
				<!--<button class="button-icon">{{ $t('Language') }}</button>-->
				<div class="dropdown-content">
					<a href="#" @click="goTo('appraisalfiles-index')"><icon name="folder-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Files') }}</a>
					<a href="#" @click="goTo('realestates-index')"><icon name="building-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Real_estates') }}</a>
					<a href="#" @click="goTo('ads-index')"><icon name="bookmark-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Ads') }}</a>
					<a href="#" @click="goTo('contacts-index')"><icon name="address-card-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Contacts') }}</a>
					<a href="#" @click="goTo('appraisalquotes-index')"><icon name="file-powerpoint-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Quotes') }}</a>
					<a href="#" @click="goTo('appraisalinvoices-index')"><icon name="eur" scale="1"></icon>&nbsp;&nbsp;{{ $t('Invoices') }}</a>
					<a href="#" @click="goTo('appraisers-index')"><icon name="user-circle-o" scale="1"></icon>&nbsp;&nbsp;{{ $t('Appraisers') }}</a>
					<a href="#" @click="goTo('supervisors-index')"><icon name="user-circle" scale="1"></icon>&nbsp;&nbsp;{{ $t('Supervisors') }}</a>
					<a href="#" @click="goTo('entities-index')"><icon name="university" scale="1"></icon>&nbsp;&nbsp;{{ $t('Entities') }}</a>
					<a href="#" @click="goTo('becproperties-index')"><icon name="tag" scale="1"></icon>&nbsp;&nbsp;{{ $t('Construction_prices') }}</a>
					<a href="#" @click="goTo('bdefiles-index')"><icon name="archive" scale="1"></icon>&nbsp;&nbsp;{{ $t('BDE_files') }}</a>
				</div>
				<!--
				<div class="dropdown-content">
					<a href="#" @click="goTo('appraisalfiles-index')"><icon name="folder-open" scale="1"></icon>&nbsp;&nbsp;{{ $t('Files') }}</a>
				</div>
				-->
			</div>

			<!--

			<li class="navli" @click.prevent="goTo('appraisalfiles-index')" v-if="filesOpen">
				<icon name="folder-open" scale="1"></icon>
				<span>&ensp;{{ $t('Files') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalfiles-index')" v-else>
				<icon name="folder-o" scale="1"></icon>
				<span>&ensp;{{ $t('Files') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('realestates-index')">
				<icon name="building-o" scale="1"></icon>
				<span>&ensp;{{ $t('Real_estates') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('ads-index')">
				<icon name="bookmark-o" scale="1"></icon>
				<span>&ensp;{{ $t('Ads') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('contacts-index')">
				<icon name="address-card-o" scale="1"></icon>
				<span>&ensp;{{ $t('Contacts') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalquotes-index')">
				<icon name="file-powerpoint-o" scale="1"></icon>
				<span>&ensp;{{ $t('Quotes') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisalinvoices-index')">
				<icon name="eur" scale="1"></icon>
				<span>&ensp;{{ $t('Invoices') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('appraisers-index')">
				<icon name="user-circle-o" scale="1"></icon>
				<span>&ensp;{{ $t('Appraisers') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('supervisors-index')">
				<icon name="user-circle" scale="1"></icon>
				<span>&ensp;{{ $t('Supervisors') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('entities-index')">
				<icon name="university" scale="1"></icon>
				<span>&ensp;{{ $t('Entities') }}</span>
			</li>
			<li class="navli" @click.prevent="goTo('becproperties-index')">
				<icon name="tag" scale="1"></icon>
				<span>&ensp;{{ $t('Construction_prices') }}</span>
			</li>
			<li class="navli">
				<icon name="archive" scale="1"></icon>
				<span>&ensp;{{ $t('BdE_files') }}</span>
			</li>
			-->

			<!--
			<router-link :to="{ name: 'dashboard'}">
				<button
						class="button-icon lnr-list">
				</button>
			</router-link>
			-->
			<!--
			<router-link :to="{ name: 'contacts-index'}">
				<button
						class="button-icon lnr-users">
				</button>
			</router-link>
			-->
		</div>
		<div class="foot__right">

			<div class="dropdown">
				<button style="border: 1px solid #DDDDDD; padding: 0.2rem;">{{ $t('Language') }}</button>
				<!--<button class="button-icon">{{ $t('Language') }}</button>-->
				<div class="dropdown-content">
					<a href="#" @click="setLanguage('ca')">Català</a>
					<a href="#" @click="setLanguage('es')">Castellano</a>
					<a href="#" @click="setLanguage('en')">English</a>
				</div>
			</div>
			<!--
			<button
					@click="onUpdateTheme"
					class="button-icon theme">
			</button>
			-->

			<dropdown></dropdown>

		</div>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Dropdown from '../Dropdown.vue'

    export default {
        name: 'bar-actions',

        computed: {
            ...mapGetters([
                'activeNote',
                'theme',
                'user'
            ])
        },

        components: {
            Dropdown
        },

        data: () => ({
            lastIndex: 0,
            quotes: [
                'BONELL+DORIGA'
            ]
        }),

        methods: {
            ...mapActions([
                'UPDATE_THEME',
				'UPDATE_LANGUAGE'
            ]),
            goTo (location,) {
                this.$router.push({name: location})
            },
            setLanguage (data) {
                this.UPDATE_LANGUAGE(data)
                    .then(() => {
                        console.log(data)
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            },
            onUpdateTheme () {
                const theme = this.theme === 'dark' ? 'light' : 'dark'
                this.UPDATE_THEME(theme)
            },

            randomQuote () {
                let index = _.random(0, this.quotes.length - 1)
                return this.quotes[index]
            }

        }

    }
</script>



// WEBPACK FOOTER //
// BarActions.vue?f9e38baa